import React, { useEffect } from 'react';
import { FormContextValues } from 'react-hook-form';
import moment from 'moment';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import GridTextField from '../../components/GridTextField';
import FormPeople from '../../types/FormPeople';
import { removeMaskIfBackspace, applyMaskOnChange } from '../../utils';
import useTypedSelector from '../../hooks/useTypedSelector';

interface Props {
  form: FormContextValues<FormPeople>;
  open: boolean;
}

export default function PeopleTabFamily({
  form,
  open,
}: Props) {

  const peopleNames: string[] = useTypedSelector(({ peopleState }) => {
    return peopleState.people.map(person => person.name);
  });

  const fatherName = form.watch('fatherName');
  const motherName = form.watch('motherName');
  const spouseName = form.watch('spouseName');

  const renderAutoCompletePerson = ({ value, name, label }: { value: string, name: string, label: string }) => {
    return (
      <Autocomplete
        freeSolo
        value={value}
        options={peopleNames}
        onInputChange={(_, newValue: string) => form.setValue(name, newValue)}
        onChange={(_, selected: string) => selected && form.setValue(name, selected)}
        noOptionsText='Nenhum cadastro encontrado'
        filterOptions={(options) => options.filter(option => {
          return option.toLowerCase().startsWith(value.toLowerCase());
        })}
        renderInput={params => (
          <TextField
            {...params}
            fullWidth
            label={label}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password',
            }}
          />
        )}
      />
    );
  };

  useEffect(() => {
    form.register({ name: 'fatherName' });
    form.register({ name: 'motherName' });
    form.register({ name: 'spouseName' });
    // @ts-ignore
    window.form = form;
  }, [ form ]);

  return (
    <Box hidden={!open}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {renderAutoCompletePerson({
            name: 'fatherName',
            value: fatherName,
            label: 'Pai',
          })}
        </Grid>
        <Grid item xs={12}>
          {renderAutoCompletePerson({
            name: 'motherName',
            value: motherName,
            label: 'Mãe',
          })}
        </Grid>
        <Grid item xs={12}>
          {renderAutoCompletePerson({
            name: 'spouseName',
            value: spouseName,
            label: 'Cônjuge',
          })}
        </Grid>
        <GridTextField
          label='Data do casamento'
          name='weddingDate'
          gridSize={6}
          inputRef={form.register({
            validate: value => {
              return !value || moment(value, 'DD/MM/YYYY').isValid() || 'Data inválida';
            },
          })}
          errorMessage={form.errors?.weddingDate?.message}
          onKeyDown={removeMaskIfBackspace}
          onChange={applyMaskOnChange('date')}
        />
        <GridTextField
          label='Número de filhos'
          name='childrenQty'
          gridSize={6}
          inputRef={form.register}
        />
      </Grid>
    </Box>
  );
}
